import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useDeleteCompanyRole, CompanyRoleListItem } from 'hooks/api'

import { Stack, Typography } from '@mui/material'

import { Modal, Button, Alert } from '@repo/ui'

interface DeleteRoleModalProps {
  role: CompanyRoleListItem | null | undefined
  open: boolean
  onClose: () => void
  onDeleted?: () => void
}

export const DeleteRoleModal = ({ role, open, onClose, onDeleted }: DeleteRoleModalProps) => {
  const { open: notification } = useSnackbar()

  const { mutate: deleteRole, isPending } = useDeleteCompanyRole({
    onSuccess: () => {
      onClose()
      onDeleted?.()
    },
    onError: (error: any) => {
      notification({ type: 'error', title: getErrorMessage(error) })
    },
  })

  const handleDelete = () => {
    if (!role?.id) return
    deleteRole(role.id)
  }

  return (
    <Modal
      title="Delete role"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={isPending}>
            Cancel
          </Button>
          <Button destructive onClick={handleDelete} disabled={isPending}>
            {isPending ? 'Deleting...' : 'Delete'}
          </Button>
        </>
      }
    >
      <Stack spacing={4} sx={{ lineHeight: 1.5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
          Are you sure you want to delete the role "{role?.name}"? This action cannot be undone.
        </Typography>
        <Alert
          severity="warning"
          description={`Users assigned to "${role?.name}" will be automatically reassigned to the Member role.`}
        />
      </Stack>
    </Modal>
  )
}
